import {useRoute} from '@react-navigation/native';
import * as React from 'react';
import {useLocality, WebRoute} from '../../../../hooks/useLocality';
import {useModal} from '../../../modal';
import {CityChangeModal} from './cityChangeModal';
import View from './view';

export const CityWidget: React.FC<{collapsed?: boolean}> = ({collapsed}) => {
  const route = useRoute<WebRoute>();
  const locality = useLocality({route});
  const modals = useModal();

  const showChangeCityModal = React.useCallback(() => {
    modals.show({
      render(modal, methods) {
        const closeModal = () => {
          methods.remove(modal.id);
        };

        return <CityChangeModal onClose={closeModal} />;
      },
    });
  }, [modals]);

  return <View cityName={locality?.name} onPress={showChangeCityModal} collapsed={collapsed} />;
};
